import { Component, OnInit } from '@angular/core';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_COTISTA_CONSULTA, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { ExportacaoAgenteFinanceiroService } from './exportacao-agente-financeiro.service';
import { ExportacaoGestorService } from './exportacao-gestor.service';
import moment from 'moment';
import { Router } from '@angular/router';

@Component({
  selector: "app-exportacao-parametros",
  templateUrl: "./exportacao-parametros.component.html",
  styleUrls: ["./exportacao-parametros.component.scss"],
  standalone: false,
})
export class ExportacaoParametrosComponent implements OnInit {
  private readonly QTD_MAX_MESES_FILTRO_DATAS = 12;

  private exportacaoGestor: boolean = false;
  private exportacaoCotista: boolean = false;

  private readonly LABELS_TELA_EXPORTACAO: {
    [key in OpcaoExportacao]: {
      titulo: string;
    };
    } = {
        'operacoes': { titulo: "Parâmetros para exportação de operações" },
        // completar com demais casos de exportacao com filtro de data
    };

  opcaoExportacao!: OpcaoExportacao | null;

  dataInicio: Date = moment().subtract(this.QTD_MAX_MESES_FILTRO_DATAS, "months").toDate();
  dataFim: Date = new Date();
  datasValidas: boolean = true;

  labelTitulo = "Parâmetros da exportação";
  labelDataInicio = "Data de início";
  labelDataFim = "Data de fim";
  msgErro: string | null = null;

  constructor(
    private fileUtils: FileUtilsService,
    private permissaoService: PermissaoService,
    private router: Router,
    private agenteService: ExportacaoAgenteFinanceiroService,
    private gestorService: ExportacaoGestorService
  ) {}

  ngOnInit(): void {
    this.permissaoService
      .getPermissoesUsuarioAutenticado()
      .subscribe((resp: any) => {
        this.exportacaoGestor = resp && resp[ROLE_GESTOR_CONSULTA];
        this.exportacaoCotista = resp && resp[ROLE_COTISTA_CONSULTA];
      });

    const url = this.router.url;
    const segmentosUrl = url.split("/").filter((s) => s.length > 0);
    this.opcaoExportacao = segmentosUrl[segmentosUrl.length - 1] as OpcaoExportacao;
    this.preencherLabels();
  }

  exportarDados() {
    this.validarDatas();

    if (this.exportacaoGestor || this.exportacaoCotista) {
      this.gestorService
        .getDadosExportacao(this.opcaoExportacao, this.dataInicio, this.dataFim)
        .subscribe((conteudoArquivo) => {
          this.fileUtils.exportarArquivoUTF8(
           `Operacoes-${moment().format('YYYYMMDD')}.csv`,
            conteudoArquivo,
            FileUtilsService.TEXT_CSV
          );
        });
    } else {
      this.agenteService
        .getDadosExportacao(this.opcaoExportacao, this.dataInicio, this.dataFim)
        .subscribe((conteudoArquivo) => {
          this.fileUtils.exportarArquivoUTF8(
            `Operacoes-${moment().format('YYYYMMDD')}.csv`,
            conteudoArquivo,
            FileUtilsService.TEXT_CSV
          );
        });
    }
  }

  validarDatas() {
    this.datasValidas = false;
    this.msgErro = null; // reset

    if (!this.dataInicio || !this.dataFim) {
      return;
    }

    const start = moment(this.dataInicio, "YYYY-MM-DD");
    const end = moment(this.dataFim, "YYYY-MM-DD");

    if (end.isBefore(start)) {
      this.msgErro = "A data de fim deve ser posterior a data de inicio.";
      return;
    }

    const maxEnd = moment(start).add(this.QTD_MAX_MESES_FILTRO_DATAS, "months");

    if (end.isAfter(maxEnd, "day")) {
      this.msgErro = `O intervalo máximo permitido é de ${this.QTD_MAX_MESES_FILTRO_DATAS} meses.`;
      return;
    }

    this.datasValidas = true;
  }

  preencherLabels() {
    this.labelTitulo = this.LABELS_TELA_EXPORTACAO[this.opcaoExportacao]?.titulo;
    this.labelDataInicio = "Data de envio inicial";
    this.labelDataFim = "Data de envio final";
  }
}